import React from 'react';

import { StyleSheet, Text, View } from 'react-native';

import TrophyIcon from 'components/icons/trophy';
import { ChallengeContainer } from 'pages/loyalty/loyalty-rewards/loyalty-rewards.styled';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { primitive } from 'styles/constants/primitives';
import { isMobile } from 'utils/environment';

import { getQuestText } from './custom-text';
import { QuestCardError, QuestCardSkeleton } from './quest-card';
import { QuestCardWrapper } from './quest-card-wrapper';
import { QuestLibraryHeader } from './quests-library/quest-library-header';
import { useUserQuest } from './use-user-quest';

export const QuestSection = ({
  showHeader = true,
  showSmallHeader = false,
}: {
  showHeader?: boolean;
  showSmallHeader?: boolean;
}) => {
  const { loyaltyUser } = useLoyaltyUser();
  const isQuestTilesEnable = useFlag(LaunchDarklyFlag.ENABLE_QUEST_TILES);
  const loyaltyId = loyaltyUser?.id;
  const { isLoading, error, refetch, userQuest, cmsQuestCardUI } = useUserQuest();

  if (!isQuestTilesEnable || !loyaltyId) {
    return null;
  }

  if (error) {
    return <QuestCardError refetch={refetch} />;
  }

  if (!userQuest || !cmsQuestCardUI) {
    return null;
  }

  if (isLoading) {
    return <QuestCardSkeleton />;
  }

  return (
    <ChallengeContainer addMargin={!showSmallHeader}>
      {showHeader &&
        (showSmallHeader ? (
          <View style={styles.title}>
            <TrophyIcon width="24px" height="18px" />
            <Text style={styles.titleText}>{getQuestText()}</Text>
          </View>
        ) : (
          <QuestLibraryHeader />
        ))}
      <QuestCardWrapper
        quest={userQuest.loyaltyQuest}
        cmsQuestCard={userQuest.cmsQuestCard}
        cmsQuestCardUI={cmsQuestCardUI}
      />
    </ChallengeContainer>
  );
};

const styles = StyleSheet.create({
  title: {
    flexDirection: 'row',
    marginBottom: isMobile() ? primitive.spacing.$3 : primitive.spacing.$4,
    gap: 8,
    alignItems: 'center',
  },
  titleText: {
    fontSize: primitive.fontSizes.lg,
    fontFamily: primitive.fontFamily.$headers,
    alignItems: 'flex-end',
    display: 'flex',
    color: primitive.bk.$bbqBrown,
  },
});
